module.exports = __webpack_public_path__ + "img/meth_maker.30dbdb5b.jpg";